var dialogTpl = function dialogTpl(content) {
  return "\n    <div class=\"milo-dialog\">\n        <div class=\"milo-dialog-mask\"></div>\n        <div class=\"milo-dialog-content\">\n            ".concat(content, "\n        </div>\n    </div>\n");
};

export default dialogTpl;